var map = {
	"./0001.mp3": "+L22",
	"./0002.mp3": "dkBL",
	"./0003.mp3": "7FH+",
	"./0004.mp3": "hKZm",
	"./0005.mp3": "lXDH",
	"./0006.mp3": "dhWo",
	"./0007.mp3": "JQWw",
	"./0008.mp3": "a13A",
	"./0009.mp3": "q9PF",
	"./0010.mp3": "zFaL",
	"./0011.mp3": "vY+g",
	"./0012.mp3": "DV8Y",
	"./0013.mp3": "IV7v"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "z9qY";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio \.*\.mp3$
// module id = z9qY
// module chunks = 0